import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3xzs38fcyp: FaireBrandEntity = {
  token: "b_3xzs38fcyp",
  type: "brand",
  name: "Fodory",
  avatarUrl:
    "https://cdn.faire.com/fastly/43b6cf7af24f841f74b0c93082d68325b038f58c3516b14e303d6ad1f1ff23c7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9951c6c72cfd0357f4792a5a325f8f0f07bf8a0a7edfd63473f2115508cdc399.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/43b6cf7af24f841f74b0c93082d68325b038f58c3516b14e303d6ad1f1ff23c7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9951c6c72cfd0357f4792a5a325f8f0f07bf8a0a7edfd63473f2115508cdc399.jpeg",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 120,
  rating: 4.8,
  reviewCount: 107,
  isInsider: true,
  description:
    "At Fodory, we believe in the quiet power of simplicity. Our home decor products are a celebration of raw materials, earthy textures, and timeless design. Inspired by nature and grounded in authenticity, we carry pieces that bring warmth, calm, and intention to modern living spaces.\n\nWe embrace imperfections, honor traditional craftsmanship, and let natural elements speak for themselves—wood, stone, linen, clay—each thoughtfully chosen to create balance and beauty in the home. Rooted in a minimalist yet soulful aesthetic, our mission is to help you return to what truly matters: connection, comfort, and conscious living.\n\nWelcome to your sanctuary. Welcome back to the basics.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:19.637Z",
    importedBy: "entity-db-cli",
  },
};
